import createIcon from '../../createIcon';

/**
 * @component @name AutoStories
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMS43NUwxNCA2Ljc1VjE3Ljc1TDE5IDEzLjI1VjEuNzVaTTEgNi43NVYyMS40QzEgMjEuNjUgMS4yNSAyMS45IDEuNSAyMS45QzEuNiAyMS45IDEuNjUgMjEuODUgMS43NSAyMS44NUMzLjEgMjEuMiA1LjA1IDIwLjc1IDYuNSAyMC43NUM4LjQ1IDIwLjc1IDEwLjU1IDIxLjE1IDEyIDIyLjI1VjYuNzVDMTAuNTUgNS42NSA4LjQ1IDUuMjUgNi41IDUuMjVDNC41NSA1LjI1IDIuNDUgNS42NSAxIDYuNzVaTTIzIDYuNzVDMjIuNCA2LjMgMjEuNzUgNiAyMSA1Ljc1VjE5LjI1QzE5LjkgMTguOSAxOC43IDE4Ljc1IDE3LjUgMTguNzVDMTUuOCAxOC43NSAxMy4zNSAxOS40IDEyIDIwLjI1VjIyLjI1QzEzLjM1IDIxLjQgMTUuOCAyMC43NSAxNy41IDIwLjc1QzE5LjE1IDIwLjc1IDIwLjg1IDIxLjA1IDIyLjI1IDIxLjhDMjIuMzUgMjEuODUgMjIuNCAyMS44NSAyMi41IDIxLjg1QzIyLjc1IDIxLjg1IDIzIDIxLjYgMjMgMjEuMzVWNi43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoStories = createIcon('AutoStories', [
  [
    'path',
    {
      d: 'M19 1.75L14 6.75V17.75L19 13.25V1.75ZM1 6.75V21.4C1 21.65 1.25 21.9 1.5 21.9C1.6 21.9 1.65 21.85 1.75 21.85C3.1 21.2 5.05 20.75 6.5 20.75C8.45 20.75 10.55 21.15 12 22.25V6.75C10.55 5.65 8.45 5.25 6.5 5.25C4.55 5.25 2.45 5.65 1 6.75ZM23 6.75C22.4 6.3 21.75 6 21 5.75V19.25C19.9 18.9 18.7 18.75 17.5 18.75C15.8 18.75 13.35 19.4 12 20.25V22.25C13.35 21.4 15.8 20.75 17.5 20.75C19.15 20.75 20.85 21.05 22.25 21.8C22.35 21.85 22.4 21.85 22.5 21.85C22.75 21.85 23 21.6 23 21.35V6.75Z',
      key: '1awbus',
    },
  ],
]);

export default AutoStories;
